module.exports = __webpack_public_path__ + "img/bg-prize-img.547b342e.png";